import { SystemStyleObject } from '@chakra-ui/react';

interface CheckboxButtonSxProps {
  container: SystemStyleObject;
  text: SystemStyleObject;
}

export const checkboxButtonSx: (isChecked: boolean) => CheckboxButtonSxProps = (
  isChecked
) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    bg: isChecked ? 'M.70' : 'M.30',
    w: 'max-content',
    rounded: 4,
    px: 3,
    py: 1.5,
  },
  text: {
    fontSize: 'sm',
    fontWeight: 500,
    color: isChecked ? 'M.10' : 'textBase',
    textAlign: 'center',
    w: 'full',
  },
});
